import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  status: null,
  message: null,
  data: [],
};

const expertDetailProfileReducer = createReducer(initialState, {
  EXPERT_PROFILE_REQ: (state) => {
    state.loading = true;
    state.data = [];
  },
EXPERT_PROFILE_FETCH_SUC: (state, action) => {
  state.loading = false;
  state.status = action.payload.status;
  state.message = action.payload.message;
  state.data = action.payload.data; // extract the data array here


  },
  EXPERT_PROFILE_ERROR: (state, action) => {
    state.loading = false;
    state.status = null;
    state.message = action.payload.message;
    state.data = [];
  },
});

export default expertDetailProfileReducer;
